import React from 'react';
import { Link } from 'react-scroll';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import MixpanelService from '../../../../services/MixpanelService';
import MixpanelConfig from '../../../../_shared/constants/mixpanelConfig';
import { StyledLabel } from './Styles';
import NowInNewStateVariants from '../../../../_shared/constants/nowInNewStateVariants';
import {
  TradeContext,
  TradeContextName,
  TradeStateNew,
  TradeStateNewName
} from '../../../../_shared/types/trade';

const defaultProps = {
  handleNavigateToTradeUri: undefined,
  tradeContext: undefined,
  isOmp: false
};

const propTypes = {
  tradeId: PropTypes.number.isRequired,
  variant: PropTypes.oneOf([
    NowInNewStateVariants.IN_UPCOMING,
    NowInNewStateVariants.IN_ACTIVE
  ]).isRequired,
  tradeContext: PropTypes.objectOf(TradeContext),
  handleNavigateToTradeUri: PropTypes.func,
  isOmp: PropTypes.bool
};

const NowInNewState = ({
  tradeId,
  variant,
  tradeContext,
  handleNavigateToTradeUri,
  isOmp
}) => {
  const intl = useIntl();
  const history = useHistory();
  const mixpanel = MixpanelService.get();

  const displayText = {
    [NowInNewStateVariants.IN_ACTIVE]: intl.formatMessage({
      id: 'vdp.pending.buyer.label.nowInActive'
    }),
    [NowInNewStateVariants.IN_UPCOMING]: intl.formatMessage({
      id: 'vdp.pending.buyer.label.nowInUpcoming'
    })
  };

  const tradeState = {
    [NowInNewStateVariants.IN_ACTIVE]: TradeStateNewName[TradeStateNew.ACTIVE],
    [NowInNewStateVariants.IN_UPCOMING]:
      TradeStateNewName[TradeStateNew.UPCOMING]
  };

  return (
    <StyledLabel>
      <Link
        to={`/trade/${tradeId}`}
        onClick={() => {
          const mixpanelEventName =
            variant === NowInNewStateVariants.IN_ACTIVE
              ? MixpanelConfig.names.linkToActiveFromExpired
              : MixpanelConfig.names.linkToUpcomingFromExpired;

          mixpanel.track(mixpanelEventName, {
            trade_id: tradeId
          });

          if (isOmp && handleNavigateToTradeUri) {
            handleNavigateToTradeUri(`/trade/${tradeId}`, {
              state: {
                state: tradeState[variant],
                context: tradeContext ? TradeContextName[tradeContext] : ''
              }
            });
          } else {
            history.push(`/trade/${tradeId}`);
          }
        }}
      >
        {displayText[variant]}
      </Link>
    </StyledLabel>
  );
};

NowInNewState.defaultProps = defaultProps;
NowInNewState.propTypes = propTypes;

export default NowInNewState;
